module.exports = __webpack_public_path__ + "static/media/logo.722b2511.svg";